import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppBreadcrumbs } from './app-breadcrumbs.component';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [
    AppBreadcrumbs

  ],
  imports: [
    BrowserModule,
    RouterModule
  ],
  exports: [
    AppBreadcrumbs
  ]
})
export class AppBreadcrumbsModule { }




// WEBPACK FOOTER //
// ./src/app/shared/components/app-breadcrumbs/app-breadcrumbs.module.ts